import React, { useState } from 'react'
import { Button, CircularProgress } from '@mui/material';
import { useNotify, useListContext, useGetIdentity } from 'react-admin';
import { joinStringArraysInObject } from 'src/helper/joinStringArraysInObject'
import { reservationServices } from 'src/services/sales/reservation/reservation.service';
import { useTranslate } from 'react-admin'
import { Download } from '@mui/icons-material'

export const ReservationExportButton = () => {
  const { filterValues } = useListContext();
  const notify = useNotify();
  const translate = useTranslate()
  const { identity } = useGetIdentity();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false)

  const handleExport = async () => {
    setLoading(true);
    try {
      const updatedFilters = joinStringArraysInObject(filterValues);
      const exported_status = await reservationServices.export(updatedFilters);
      if (exported_status === 200) {
        notify('ra.message.export_success', { type: 'success', messageArgs: { email: identity?.email } });
      } else {
        notify('ra.message.export_error', { type: 'error' });
      }
    } catch (error) {
      notify('ra.message.export_error', { type: 'error' });
    } finally {
      setLoading(false);
      setExportLoading(true)
      setTimeout(()=>{setExportLoading(false)}, 10000)
    }
  };

  return (
    <Button
      onClick={handleExport}
      disabled={loading || exportLoading}
      startIcon={loading ? <CircularProgress size={20} /> : <Download fontSize='small' />}
      sx={{ lineHeight: '1.5'}}
      size='small'
    >
      {translate('ra.action.export')}
    </Button>
  )
};

